module.exports = __webpack_public_path__ + "img/0b99a3b.png";